module.exports = __webpack_public_path__ + "static/img/logo-side-menu.5922906.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo-side-menu.png
// module id = 757
// module chunks = 0